module.exports = __webpack_public_path__ + "img/logo-allbridge.7033c72a.png";